import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-758edabe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "input-container"
}
const _hoisted_2 = { class: "input-fieldset" }
const _hoisted_3 = { for: "login-email" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "input-fieldset" }
const _hoisted_7 = { for: "login-pwd" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "input-container"
}
const _hoisted_11 = { class: "code-fieldset" }
const _hoisted_12 = { for: "authcode" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 3,
  class: "alink"
}
const _hoisted_16 = {
  key: 2,
  class: "input-container"
}

import { ref } from "vue";
import { index } from '@/store';
import { translate } from "@/util/intl";
import { CognitoService } from "@/backend/cognito";
import PasswordForgotten from "./PasswordForgotten.vue";
import router from '../router';
import { AuthMethod } from "@/backend/types/login";
import CustomSpinner from "@/components/CustomSpinner.vue";
import AlertOverlay from "@/components/AlertOverlay.vue";
import { AppState } from "@/store/app-state";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordLogin',
  setup(__props) {

const cognito = new CognitoService();

// data refs
const email = ref("");
const pwd = ref("");
const authcode = ref("");
// state refs
const isValidEmail = ref(true);
const isValidPassword = ref(true);
const atLogin = ref(true);
const verifying = ref(false);
const pwdForgot = ref(false);
const inProcess = ref(false);
const loginFail = ref(false);
const noCodeReceived = ref(false);
const faultyCode = ref(false);
const recentlySent = ref(false);

let codeTimeoutId: number; // ID from setTimeout, used for canceling timeout
let loginErrMsg: string;

// timeout value must match flow session duration in Cognito, idk how to get Cognito itself to tell session ended
function startCodeInputCountdown() {
  codeTimeoutId = setTimeout(async () => {
    index.commit("SET_APP_STATE", AppState.Logout);
    await router.push("/logout?expired");
  }, 10 * 60 * 1000);
}

function showLogin() {
  atLogin.value = true;
  verifying.value = false;
  pwdForgot.value = false;
}

function showVerification() {
  atLogin.value = false;
  verifying.value = true;
  pwdForgot.value = false;
  startCodeInputCountdown();
  setTimeout(() => {
    noCodeReceived.value = true;
  }, 8000);
}

function showPwdForgot() {
  atLogin.value = false;
  verifying.value = false;
  pwdForgot.value = true;
}

/**
 * Does login and on success shows 2FA code input field via callback
 */
function login(): void {
  isValidEmail.value = true;
  isValidPassword.value = true;
  const m = email.value.trim();
  const p = pwd.value.trim();
  if (!cognito.validateEmail(m)) {
    isValidEmail.value = false;
  }
  if (!cognito.validatePassword(p)) {
    isValidPassword.value = false;
  }
  if (isValidEmail.value && isValidPassword.value) {
    index.commit("SET_USER_COGNITO_ID", m);
    cognito.loginUser(m, p, showVerification)
      .catch(err => {
        loginErrMsg = err;
        loginFail.value = true;
      })
      .finally(() => {
        inProcess.value = false
      });
  }
}

async function verifyLoginCode() {
  clearTimeout(codeTimeoutId);
  faultyCode.value = false;
  const a = authcode.value.trim();
  if (a === "") {
    return;
  }
  inProcess.value = true;
  cognito.submitLoginCode(a, index.getters.getCognitoId)
    .then(() => {
      clearTimeout(codeTimeoutId);
      index.commit("SET_USER_AUTH_METHOD", AuthMethod.COGNITO);
      router.push("/login");
    }, () => {
      faultyCode.value = true;
    })
    .finally(() => inProcess.value = false);
}

function resendLoginCode() {
  if (!recentlySent.value) {
    clearTimeout(codeTimeoutId);
    recentlySent.value = true;
    // this trick should work, but I think something restricts how often codes can be sent
    login();
    setTimeout(() => {
      recentlySent.value = false;
    }, 10000);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (atLogin.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", null, _toDisplayString(_unref(translate)("generic-login")) + " (1/2)", 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(translate)("email")), 1),
            _withDirectives(_createElementVNode("input", {
              id: "login-email",
              type: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              onKeyup: _withKeys(login, ["enter"]),
              autofocus: ""
            }, null, 544), [
              [_vModelText, email.value]
            ]),
            (!isValidEmail.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(translate)("invalid-email")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_5))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)("password")), 1),
            _withDirectives(_createElementVNode("input", {
              id: "login-pwd",
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pwd).value = $event)),
              onKeyup: _withKeys(login, ["enter"])
            }, null, 544), [
              [_vModelText, pwd.value]
            ]),
            (!isValidPassword.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(translate)("invalid-password")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_9))
          ]),
          _createElementVNode("button", {
            class: "buttonContinue",
            onClick: login
          }, _toDisplayString(_unref(translate)("generic-login")), 1),
          _createElementVNode("a", {
            class: "alink",
            onClick: showPwdForgot
          }, _toDisplayString(_unref(translate)("forgot-password-q")), 1)
        ]))
      : (verifying.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("h2", null, _toDisplayString(_unref(translate)("generic-login")) + " (2/2)", 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", null, _toDisplayString(_unref(translate)("give-sms-code")), 1),
              _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(translate)("auth-code")) + " (SMS)", 1),
              _withDirectives(_createElementVNode("input", {
                id: "authcode",
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((authcode).value = $event)),
                onKeyup: _withKeys(verifyLoginCode, ["enter"]),
                autofocus: ""
              }, null, 544), [
                [_vModelText, authcode.value]
              ]),
              (faultyCode.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(translate)("faulty-mfa-code")), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_14)),
              _createElementVNode("button", {
                class: "buttonContinue",
                onClick: verifyLoginCode
              }, _toDisplayString(_unref(translate)("verify")), 1),
              (noCodeReceived.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: "alink",
                    href: "#",
                    onClick: resendLoginCode
                  }, _toDisplayString(_unref(translate)("no-code-received-q")), 1))
                : (_openBlock(), _createElementBlock("a", _hoisted_15))
            ])
          ]))
        : (pwdForgot.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(PasswordForgotten, { onReseted: showLogin }),
              _createElementVNode("a", {
                class: "alink",
                onClick: showLogin
              }, _toDisplayString(_unref(translate)("login-q")), 1)
            ]))
          : _createCommentVNode("", true),
    _createVNode(CustomSpinner, { loading: inProcess.value }, null, 8, ["loading"]),
    (loginFail.value)
      ? (_openBlock(), _createBlock(AlertOverlay, {
          key: 3,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (loginFail.value = false)),
          title: _unref(translate)('login-problem'),
          text: _unref(loginErrMsg)
        }, null, 8, ["title", "text"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})